export default __webpack_public_path__ + "static/media/about-us-hero-arrow.5833ae45.svg";